import { PageWithLayout } from '@/pages/_app';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { Permission } from '@/models/user';
import { ProductionContent } from '@/pageContents/production/ProductionContent';

const Production: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Produktion | Starjack Backoffice</title>
            </Helmet>

            <ProductionContent />
        </>
    );
};

Production.isProtected = true;
Production.permissions = [Permission.ADMIN];
Production.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;

export default Production;
